var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scroll",
    clipPath: "url(#clip0_0_22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.5625 23.375V8.50002C26.5625 7.65464 26.2266 6.84389 25.6289 6.24612C25.0311 5.64835 24.2203 5.31252 23.375 5.31252H5.31246",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 2.3356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.8125 13.8125H22.3125",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 2.3356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.8125 18.0625H22.3125",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 2.3356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.18742 10.625C3.18742 10.625 2.12492 9.82815 2.12492 8.50002C2.12492 7.65464 2.46074 6.84389 3.05851 6.24612C3.65629 5.64835 4.46704 5.31252 5.31242 5.31252C6.15779 5.31252 6.96855 5.64835 7.56632 6.24612C8.16409 6.84389 8.49992 7.65464 8.49992 8.50002V25.5C8.49992 26.3454 8.83574 27.1562 9.43351 27.7539C10.0313 28.3517 10.842 28.6875 11.6874 28.6875M11.6874 28.6875C12.5328 28.6875 13.3435 28.3517 13.9413 27.7539C14.5391 27.1562 14.8749 26.3454 14.8749 25.5C14.8749 24.1719 13.8124 23.375 13.8124 23.375H28.6874C28.6874 23.375 29.7499 24.1719 29.7499 25.5C29.7499 26.3454 29.4141 27.1562 28.8163 27.7539C28.2185 28.3517 27.4078 28.6875 26.5624 28.6875H11.6874Z",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 2.3356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.fdf243c9d69decd2bcaca5f5920c6412.svg";
export { ForwardRef as ReactComponent };